import { render } from "./SalesBranches.vue?vue&type=template&id=032492de&scoped=true"
import script from "./SalesBranches.vue?vue&type=script&lang=js"
export * from "./SalesBranches.vue?vue&type=script&lang=js"

import "./SalesBranches.vue?vue&type=style&index=0&id=032492de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032492de"]])

export default __exports__